import { render, staticRenderFns } from "./Appmain.vue?vue&type=template&id=e96d69c4"
import script from "./Appmain.vue?vue&type=script&lang=js"
export * from "./Appmain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports